import store from '../store/index';
import { PAGE_SIZE_CELL, PAGE_CELL_HEIGHT, PAGE_LAYOUT_TOP } from '@/subjects/constant';
const MARGIN_BOTTOM = 10; // 每个页面底部空白的高度值为10px
//@ts-ignore
let answerPanelState = store.state.answerPanel;
//@ts-ignore
let cardState = store.state.card;

interface FillTopiclist {
  type: number | string | undefined;
  initDragHeight: number;
  innerHTML: string | undefined;
  isResolved?: boolean;
  isHurdle?: boolean;
  isSub?: boolean;
}

interface PageCellItem {
  fillTopiclist: Array<FillTopiclist>;
}
export default class MyPage {
  topic: any;

  constructor(topic?: any) {
    this.topic = topic || {};
  }

  /**
   * 创建新的一2页
   * @param {number} overstepDistance 超过当前页面最大高度的超出部分
   */

  createNextPage(pageCell: Array<PageCellItem>) {
    const newPageCellData = {
      //  答题卡页面的布局
      layout: {
        // 三栏
        // width: PAGE_SIZE_CELL[0],
        width:
          answerPanelState.answerSheet.acCardPanes == 3 ? PAGE_SIZE_CELL[1] : PAGE_SIZE_CELL[0],
        height: PAGE_CELL_HEIGHT,
        position: 'absolute',
        top: `${Number(parseInt(String((PAGE_LAYOUT_TOP - 20) * pageCell.length))) + 10}`,
        left: '50%',
        // padding: '62px 29px',
        padding: '62px 44px',
        marginLeft: -353,
      },
      // 每种题型的内容高度（就是去除纸张上面考生信息的高度）
      contentHeight: PAGE_CELL_HEIGHT - this.headerBasicHeight(),
      // 填空题
      fillTopiclist: [],
      items: [],
    };
    store.commit('card/addPageCell', newPageCellData);
  }

  /**
   * 在下一页的头栈插入多出的高度
   */
  insertNextPageHeadStack(
    nextPageCell: PageCellItem,
    overstepDistance: number,
    type?: number | string | undefined,
    innerHTML?: string,
    topic?: object,
    no?: any
  ) {
    // nextPageCell.items.push({
    //   type: state.topticType || 1,
    // });

    nextPageCell.fillTopiclist.unshift({
      ...this.topic,
      no: no,
      type: type,
      isHurdle: false, //当前item是否属于跨栏内容
      isResolved: false, // 题型是否分解
      isSub: true, // 是否由拖拽生成的子题型stack
      initDragHeight: overstepDistance,
      ...topic,
      innerHTML: innerHTML || '',
    });
  }

  getPageSurplus(state: any, currentPage: number): number {
    const currentMaxHeight =
      (state.pageCell[currentPage] && state.pageCell[currentPage].contentHeight) || 0;
    const canFillHeight = currentMaxHeight - state.existHeight; // 可填充高度    
    console.log('MyPage ::::: getPageSurplus', canFillHeight);
    return canFillHeight;
  }

  /**
   * 添加题目时是否剩余空间
   * @param state
   * @param currentPage
   * @param minSubjectHeight
   */
  isSurplusPage(state: any, currentPage: number, minSubjectHeight: number) {
    let {acCardYJType    } = answerPanelState.answerSheet

    const canFillHeight = this.getPageSurplus(state, currentPage);
    
    return canFillHeight >= minSubjectHeight;
    // return canFillHeight >= (minSubjectHeight + acCardYJType == 2 ? 40 : 0 );
  }

  /**
   * 创建下一页是否需要展示考生填写信息
   */
  hasBasicByCreateNextPage() {
    const { acCardPanes, acCardPint } = answerPanelState.answerSheet;
    const pageCell = cardState.pageCell;
    const nextPageCell = pageCell.length + 1;
    
    if (acCardPanes === 1) {
      // 一栏
      if (acCardPint == 1) {
        // 单面打印
        return true;
      } else if (acCardPint == 2) {
        // 双面打印
        return nextPageCell % 2 == 1 ? true : false;
      }
    } else if (acCardPanes === 2) {
      // 二栏
      if (acCardPint == 1) {
        // 单面打印
        return nextPageCell % 2 == 1 ? true : false;
      } else if (acCardPint == 2) {
        // 双面打印
        return nextPageCell % 4 == 1 ? true : false;
      }
    } else {
      // 三栏
      if (acCardPint == 1) {
        // 单面打印
        return nextPageCell % 3 == 1 ? true : false;
      } else if (acCardPint == 2) {
        // 双面打印
        return nextPageCell % 6 == 1 ? true : false;
      }
    }
  }

  deleteEmptyPage() {
    // 每次更新高度查看是否有空白页面有则删除
    const pageCell = cardState.pageCell;
    pageCell.forEach((page: any, index: number) => {
      if (!page.fillTopiclist.length) {
        // 当前page没有题型
        index && pageCell.splice(index, 1);// 第一页空页也不能删除
      }
    });
  }
  // 考生填写信息头部的高度
  headerBasicHeight(): number {
    const { acCardPanes, acCardStudentCodeType, acCardExamNumber } = answerPanelState.answerSheet;
    const flag = this.hasBasicByCreateNextPage();
    let height = 0;    
    if (flag) {
      if (acCardStudentCodeType === 1) {
        // 考号填写模式 => 条码
        height = 243 + MARGIN_BOTTOM * 2;
        if(acCardPanes === 3) {
          height = 274 + MARGIN_BOTTOM * 2;
        }
      } else if (acCardStudentCodeType === 2) {
        // 考号填写模式 => 手写考号
        // height = 252;
        // MARGIN_BOTTOM*2  增加的20是因为有一个basic marginbottom 20px的距离
        height = 283 + MARGIN_BOTTOM * 2;
        // if(acCardPanes === 3) {
        //   height = 345 + MARGIN_BOTTOM * 2;
        // }

      } else if (acCardStudentCodeType === 0) {
        // 考号填写模式 => 填涂
        // if (
        //   (acCardPanes === 2 && acCardExamNumber > 9) ||
        //   (acCardPanes === 3 && acCardExamNumber > 8) ||
        //   (acCardPanes === 1 && acCardExamNumber > 10)
        // ) {
        //   height = 345;
        // } else {
        //   height = 304;
        // }
        height = 283 + MARGIN_BOTTOM * 2;
      }
    }
    return height;
  }
}
